export default __webpack_public_path__ + "static/media/pexels-melvin-buezo-2529147-min.b87d142f.jpg";